import type { ErrorResponse } from 'schemas';

/**
 * Type guard to check if an object is an ErrorResponse
 */
export function isErrorResponse(obj: unknown): obj is ErrorResponse {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    (obj as { type?: string }).type === 'error' &&
    typeof (obj as { error?: string }).error === 'string' &&
    typeof (obj as { code?: string }).code === 'string' &&
    typeof (obj as { message?: string }).message === 'string'
  );
}
